/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const CreateSocialUploadDtoSourceTypeEnum = {
    FRAGMENT: "FRAGMENT",
    VIDEO_EDITOR_EDIT: "VIDEO_EDITOR_EDIT"
} as const;

export type CreateSocialUploadDtoSourceTypeEnumKey = (typeof CreateSocialUploadDtoSourceTypeEnum)[keyof typeof CreateSocialUploadDtoSourceTypeEnum];

export const CreateSocialUploadDtoPlatformEnum = {
    YOUTUBE: "YOUTUBE",
    TWITTER: "TWITTER",
    INSTAGRAM: "INSTAGRAM",
    DAILYMOTION: "DAILYMOTION",
    FACEBOOK: "FACEBOOK",
    DEMO: "DEMO",
    TIKTOK: "TIKTOK"
} as const;

export type CreateSocialUploadDtoPlatformEnumKey = (typeof CreateSocialUploadDtoPlatformEnum)[keyof typeof CreateSocialUploadDtoPlatformEnum];

export type CreateSocialUploadDto = {
    /**
     * @description Whether the upload is for fragment media or a video-editor edit.
     * @type string
    */
    sourceType: CreateSocialUploadDtoSourceTypeEnumKey;
    /**
     * @description Fragment ID when sourceType is FRAGMENT, edit ID when VIDEO_EDITOR_EDIT.
     * @type string, uuid
    */
    sourceId: string;
    /**
     * @description The platform where the media will be uploaded
     * @type string
    */
    platform: CreateSocialUploadDtoPlatformEnumKey;
    /**
     * @description OAuth connection id; required when sourceType is VIDEO_EDITOR_EDIT.
     * @type string | undefined, uuid
    */
    connectionId?: string;
    /**
     * @description Platform-specific publish configuration
     * @type object
    */
    data: {
        [key: string]: any;
    };
};